import { stringify } from 'qs'
import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../../loadJsonApiEntities'

const fetchContent = ({ fields, filter, include, page, omit_count }) => {
  const queryString = stringify(
    {
      fields,
      filter,
      include: include.join(','),
      page,
      omit_count,
    },
    { arrayFormat: 'brackets' }
  )
  return HttpClient().get(`/content/v2?${queryString}`)
}

const getContent =
  ({
    fields = {},
    filter = {},
    include = [],
    page = { limit: 999999, offset: 0 },
    omit_count = false,
  }) =>
  async (dispatch) =>
    fetchContent({
      fields,
      filter,
      include,
      page,
      omit_count,
    })
      .then((response) => {
        dispatch(loadJsonApiEntities(response.data))
        // Resolve with this page's item count so a paginating caller can tell
        // whether the page came back full (i.e. there may be another page).
        return response.data?.data?.length ?? 0
      })
      .catch((err) => {
        console.log(err)
        throw err
      })

export default getContent
